import React, { useState, useEffect } from 'react';
import {
  GeckoModal,
  GeckoModalService,
  GECKO_CONSTS,
  GeckoToastService,
} from '../../../ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { GeckoFields } from '../../../ui';
import AgentTeamSelect from 'components/AgentTeamSelect';

const AssignConversationModal = ({ conversation, setActionTimestamp }) => {
  const [newAssignedAgentsTeams, setNewAssignedAgentsTeams] = useState([]);

  const assignedAgents = conversation.assignedAgentIds.map((id) => {
    return `agent_${id}`;
  });

  const assignedTeams = conversation.assignedTeamIds.map((id) => {
    return `team_${id}`;
  });

  const combinedAssignments = [...assignedAgents, ...assignedTeams];

  useEffect(() => {
    setNewAssignedAgentsTeams(combinedAssignments);
  }, []);

  const field = () => {
    return [
      {
        key: 'value',
        label: 'Agents / Teams currently assigned to this conversation',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <AgentTeamSelect value={values} multi={true} />,
        placeholder: 'Filter by Agents & Teams',
        width: '100',
      },
    ];
  };

  const values = { value: newAssignedAgentsTeams };

  const handleChange = (_key, value) => {
    setNewAssignedAgentsTeams(value);
  };

  return (
    <GeckoModal
      name="Assign agents / teams to this conversation"
      children={
        <GeckoFields fields={field()} values={values} handler={handleChange} />
      }
      btns={[
        {
          name: 'Cancel',
          secondary: true,
          icon: 'far fa-times',
          handler: () => {
            return new GeckoModalService().close();
          },
        },
        {
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          name: 'Done',
          icon: 'far fa-check-double',
          handler: () => {
            GeckoRequest.post(
              `/conversation/${conversation.id}/update-assignments`,
              {
                assignments: newAssignedAgentsTeams,
              }
            )
              .then(() => {
                new GeckoModalService().close();
                new GeckoToastService().success('Assignments Updated');
                setActionTimestamp(Date.now());
              })
              .catch(renderError);
          },
        },
      ]}
    />
  );
};

export default AssignConversationModal;
